import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import MenuItemViewModelType from '@/ViewModels/Controls/MenuItemViewModel';
import LinkType from '@/Controls/Link';
import ImageType from '@/Controls/Image';
import EventHelper from '@/Utility/EventHelper';

export default class MenuItem extends Control {

    private Link = ComponentManager.getControl<typeof LinkType>('Link');
    private Image = ComponentManager.getControl<typeof ImageType>('Image');
    private jQueryControl: JQuery;
    private link: LinkType;
    private image: ImageType;

    public constructor(private viewModel: MenuItemViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<li>');

        this.viewModel.isOpen(false); // Initial ist jeder Menüpunkt geschlossen

        this.applyBindings(this.jQueryControl, {
            kendoMenuItem: {
                enabled: this.viewModel.isEnabled,

                widget: this.widget
            }
        });

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: any): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'menuitem',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            visible: this.viewModel.isVisible,

            menuItemIsOpen: { state: this.viewModel.isOpen, widget: widget },

            menuItems: {
                parent: this,

                items: this.viewModel.items,

                widget: this.widget
            },

            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isOpen() === true) {
                        states.push('open');
                    } else {
                        states.push('closed');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });

        if (this.viewModel.link != null) {
            this.link = new this.Link(this.viewModel.link);
            let tuple = this.link.getTuple();
            let span = this.jQueryControl.children('.k-link').first();

            this.applyBindings(span, {
                locator: this.viewModel.locator
            });
            
            //Delegiere Klick-Event an Link-Control, wenn der Link nicht angeklickt wurde.
            EventHelper.bindClickEvent(span, (openInNewWindow, event) => {
                if (!this.isDisposed && this.viewModel.isEnabled()) {
                    //Simuliere 'mousedown' Event auf dem Element: Sicherstellen, dass im EventHelper beim MouseDown das Element in einer Temp-Variablen gespeichert wird.
                    //Das Click-Callback wird nur ausgelöst, wenn das Element in MouseDown gleich dem Element in MouseUp ist.
                    tuple.control.trigger('mousedown');
                    //Ändere das Event 'target' auf das Link-Control
                    event.target = tuple.control[0];
                    //Aufrufen des Eventhandler des Link-Controls
                    tuple.control.triggerHandler(event);
                }
            }, this);

            //Verhinde die Bubbling Phase, wenn der Link angeklickt wurde.
            EventHelper.bindClickEvent(tuple.control, (openInNewWindow, event) => {
                if ((!this.isDisposed && this.viewModel.isEnabled()) && event.originalEvent.type === 'touchend') {
                    // delegiere das Event weiter an den Link im Container
                    const closestLink = $(event.target).closest('a.c-link')[0];
                    closestLink?.click();
                    closestLink?.blur();
                }
                event.stopPropagation();
            }, this.link);

            tuple.control.prependTo(span);
        }

        if (this.viewModel.image != null) {
            this.image = new this.Image(this.viewModel.image);
            let tuple = this.image.getTuple();

            tuple.control.appendTo(this.jQueryControl.find('.c-link'));
        }
    }
}

ComponentManager.setControl('MenuItem', MenuItem, 'RADPresentation.HTMLClient.DefaultViewExtensions');